import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=119a5b0f"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119a5b0f')) {
      api.createRecord('119a5b0f', component.options)
    } else {
      api.reload('119a5b0f', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=119a5b0f", function () {
      api.rerender('119a5b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/Templates.vue"
export default component.exports